<script setup lang="ts">
import tailwindConfig from "../../../tailwind.config";

withDefaults(
  defineProps<{
    color?: string;
  }>(),
  {
    color: tailwindConfig.theme.extend.colors["ppa-dark-blue"],
  },
);
</script>

<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="none"
  >
    <path
      d="M20 5H10.414L8.707 3.293C8.61426 3.2 8.50406 3.12624 8.38273 3.07596C8.2614 3.02568 8.13134 2.99986 8 3H4C2.897 3 2 3.897 2 5V19C2 20.103 2.897 21 4 21H20C21.103 21 22 20.103 22 19V7C22 5.897 21.103 5 20 5Z"
      :fill="color"
    />
    <path
      d="M9.9 13.1C11.4466 13.1 12.7 11.8463 12.7 10.3C12.7 8.75366 11.4466 7.5 9.9 7.5C8.35344 7.5 7.1 8.75366 7.1 10.3C7.1 11.8463 8.35344 13.1 9.9 13.1ZM11.0091 14.15H8.79094C6.69684 14.15 5 15.8475 5 17.9409C5 18.3609 5.3395 18.7 5.75819 18.7H14.0409C14.4609 18.7 14.8 18.3609 14.8 17.9409C14.8 15.8475 13.1025 14.15 11.0091 14.15ZM15.4803 14.5H13.8648C14.87 15.3247 15.5 16.5584 15.5 17.9409C15.5 18.2209 15.4169 18.4791 15.2812 18.7H18.3C18.6872 18.7 19 18.385 19 17.9803C19 16.0663 17.4338 14.5 15.4803 14.5ZM14.45 13.1C15.8041 13.1 16.9 12.0041 16.9 10.65C16.9 9.29594 15.8041 8.2 14.45 8.2C13.9007 8.2 13.3991 8.38714 12.9905 8.69241C13.2425 9.17628 13.4 9.71813 13.4 10.3C13.4 11.077 13.139 11.7906 12.709 12.3718C13.1528 12.82 13.7675 13.1 14.45 13.1Z"
      fill="white"
    />
  </svg>
</template>
